import { render, staticRenderFns } from "./buildDiscount.vue?vue&type=template&id=5a26e70c&"
import script from "./buildDiscount.vue?vue&type=script&lang=js&"
export * from "./buildDiscount.vue?vue&type=script&lang=js&"
import style0 from "./buildDiscount.vue?vue&type=style&index=0&id=5a26e70c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports